import {sample} from "effector";
import {sendRequestDemoFx} from "./effects";
import {resetShowPopupEv, sendRequestDemoEv, togglePostPopupEv, toggleShowMenuEv} from "./events";
import {$postPopup, $showMenu, $showPopup} from "./stores";
import dayjs from "dayjs";

$showPopup.on(sendRequestDemoFx.doneData, (state, _) => true)
	.reset(resetShowPopupEv)

$showMenu.on(toggleShowMenuEv, (state, _) => !state)

$postPopup.on(togglePostPopupEv, (state, payload) => !state)
	.on(sendRequestDemoFx.doneData, (state, _) => false)

sample({
	clock: sendRequestDemoEv,
	fn: (clock) => {
		return {
			...clock,
			seventh_value: dayjs().format('YYYY-MM-DD')
		}
	},
	target: sendRequestDemoFx
})

